var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{staticClass:"custom-header",attrs:{"wrap":""}},_vm._l((_vm.items),function(item,index){return _c('header-values',_vm._b({key:index,on:{"clickHandler":function($event){return item.clickHandler()}}},'header-values',item,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }